import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#202948",
      "fill-rule": "evenodd",
      d: "M6.834 12.91a6.075 6.075 0 1 0 0-12.15 6.075 6.075 0 0 0 0 12.15m0 .759A6.834 6.834 0 1 0 6.834 0a6.834 6.834 0 0 0 0 13.669",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#202948",
      "fill-rule": "evenodd",
      d: "M8.344 4.556a1.519 1.519 0 1 1-3.038 0 1.519 1.519 0 0 1 3.038 0m.76 0a2.278 2.278 0 1 1-4.557 0 2.278 2.278 0 0 1 4.556 0M6.824 8.1a3.797 3.797 0 0 1 3.789 3.544h.76a4.556 4.556 0 0 0-9.098 0h.76A3.797 3.797 0 0 1 6.825 8.1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }